import React, { PureComponent } from 'react';
import { Link } from 'react-router-dom';

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import classnames from 'classnames';
import { Alert } from 'components/cosmos';
import Html from 'components/Html';
import { translate } from 'components/translate';
import { ROUTES } from 'configs/routes/constants';
import { inject } from 'mobx-react';
import { TABS } from 'modules/salesManager/constants';
import PropTypes from 'prop-types';

import { VARIANT, DEFAULT_VARIANT } from './constant';

import './OfferToast.scss';

class OfferToast extends PureComponent {
  static propTypes = {
    t: PropTypes.func,
    variant: PropTypes.string,
    isMobile: PropTypes.bool,
    onScrollToOffers: PropTypes.func,
    showable: PropTypes.bool
  };

  static defaultProps = {
    variant: DEFAULT_VARIANT,
    showable: true
  };

  constructor(props) {
    super(props);

    this._toastProps = {
      [VARIANT.DASHBOARD]: {
        labelPath: 'toast_offer.dashboard',
        renderDescription: this.renderDescriptionDashboard,
        className: 'offer_toast__dashboard'
      },
      [VARIANT.SALES_INFO]: {
        labelPath: 'toast_offer.sales_info',
        renderDescription: this.renderDescriptionSales,
        className: 'offer_toast__sales'
      }
    };

    this.salesLinkProps = {
      className: '_text-blue-dark',
      to: {
        pathname: ROUTES.SALES,
        state: { tabIndex: TABS.SALES_INFO }
      }
    };

    this.state = {
      showable: props.showable
    };
  }

  get toastProps() {
    const { variant } = this.props;

    return this._toastProps[variant] || this._toastProps[DEFAULT_VARIANT];
  }

  get className() {
    const { className } = this.toastProps;

    return classnames('offer_toast', className);
  }

  get labelPath() {
    const { labelPath } = this.toastProps;

    return labelPath || '';
  }

  get linkMessage() {
    const { isMobile } = this.props;

    return isMobile ? 'message_link_mobile' : 'message_link_desktop';
  }

  onClose = () => {
    this.setState({ showable: false });
  };

  renderDescriptionDashboard = () => {
    const { t } = this.props;

    return (
      <div className="offer_toast__dashboard__body">
        <Html>{t(`${this.labelPath}.message_important`)}</Html>
        {` `}
        <Link {...this.salesLinkProps}>
          {t(`${this.labelPath}.message_link`)}
        </Link>
        {` `}
        {t(`${this.labelPath}.message_to_choose`)}
      </div>
    );
  };

  renderDescriptionSales = () => {
    const { t, onScrollToOffers, isMobile } = this.props;

    return (
      <div>
        <Html>{t(`${this.labelPath}.message`)}</Html>
        {` `}
        <a
          onClick={onScrollToOffers}
          className="_text-blue-dark _cursor-pointer"
        >
          {t(`${this.labelPath}.${this.linkMessage}`)}
        </a>
        {!isMobile && (
          <FontAwesomeIcon icon={['fal', 'arrow-down']} className="_ml-1" />
        )}
        {`.`}
      </div>
    );
  };

  render() {
    const { showable } = this.state;

    if (!showable) {
      return null;
    }

    return (
      <Alert type="info" dismissible onDismiss={this.onClose}>
        <div className="_d-flex _align-items-center _justify-content-between">
          <FontAwesomeIcon
            icon={['fal', 'exclamation-circle']}
            className="_mr-4"
          />
          {this.toastProps.renderDescription()}
        </div>
      </Alert>
    );
  }
}

export default translate()(
  inject((stores) => ({
    isMobile: stores.UiStore.isMobile
  }))(OfferToast)
);

export { OfferToast };
